import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Page/page';
export var PageGroup = function PageGroup(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      children = _a.children,
      sticky = _a.sticky,
      _a$hasShadowTop = _a.hasShadowTop,
      hasShadowTop = _a$hasShadowTop === void 0 ? false : _a$hasShadowTop,
      _a$hasShadowBottom = _a.hasShadowBottom,
      hasShadowBottom = _a$hasShadowBottom === void 0 ? false : _a$hasShadowBottom,
      _a$hasOverflowScroll = _a.hasOverflowScroll,
      hasOverflowScroll = _a$hasOverflowScroll === void 0 ? false : _a$hasOverflowScroll,
      props = __rest(_a, ["className", "children", "sticky", "hasShadowTop", "hasShadowBottom", "hasOverflowScroll"]);

  return React.createElement("div", Object.assign({}, props, {
    className: css(styles.pageMainGroup, sticky === 'top' && styles.modifiers.stickyTop, sticky === 'bottom' && styles.modifiers.stickyBottom, hasShadowTop && styles.modifiers.shadowTop, hasShadowBottom && styles.modifiers.shadowBottom, hasOverflowScroll && styles.modifiers.overflowScroll, className)
  }), children);
};
PageGroup.displayName = 'PageGroup';